module.exports = __webpack_public_path__ + "img/ry_10.0ac2cb33.png";